import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { DownloadSimple, ArrowRight, ShieldCheck } from "@phosphor-icons/react";
import { useSettings } from "../../lib/api";

const GOV_IMG =
  "https://images.pexels.com/photos/7884225/pexels-photo-7884225.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const GovernmentCTA = () => {
  const { data: s } = useSettings();

  return (
    <section data-testid="government-cta-section" className="relative bg-[#090A0C] py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0 blueprint-grid opacity-40" style={{ ["--grid-line" as string]: "rgba(59,130,246,0.08)" }} />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="font-mono-tech text-[11px] tracking-[0.25em] uppercase text-[#FFD60A] mb-5 flex items-center gap-2">
            <ShieldCheck size={16} /> 03 — Government Contracting
          </p>
          <h2 className="font-heading font-medium text-3xl md:text-4xl tracking-tight text-white">
            A mission-ready SDVOSB partner for federal, state & municipal agencies.
          </h2>
          <p className="mt-6 text-white/60 leading-relaxed max-w-lg">
            From set-aside task orders to IDIQ execution, FOSCHE brings compliance rigor, transparent reporting, and
            veteran discipline to every government engagement.
          </p>
          <div className="mt-8 grid grid-cols-2 gap-px bg-white/10 border border-white/10 max-w-md">
            <div className="bg-[#090A0C] p-5">
              <p className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-white/40">UEI</p>
              <p className="mt-1 text-sm text-white">{s?.uei || "SAM.gov Registered"}</p>
            </div>
            <div className="bg-[#090A0C] p-5">
              <p className="font-mono-tech text-[10px] tracking-[0.2em] uppercase text-white/40">CAGE</p>
              <p className="mt-1 text-sm text-white">{s?.cage || "Available Upon Request"}</p>
            </div>
          </div>
          <div className="mt-9 flex flex-wrap gap-4">
            <a
              href="/FOSCHE-Capability-Statement.pdf?v=3"
              download
              data-testid="gov-capability-download-btn"
              className="inline-flex items-center gap-3 px-6 py-3.5 bg-[#3B82F6] text-white text-sm font-medium transition-all hover:bg-[#FFD60A] hover:text-black"
            >
              <DownloadSimple size={16} /> Download Capability Statement
            </a>
            <Link
              to="/government"
              data-testid="gov-learn-more-btn"
              className="inline-flex items-center gap-2 px-6 py-3.5 border border-white/25 text-white text-sm font-medium transition-colors hover:border-[#FFD60A] hover:text-[#FFD60A]"
            >
              Government Services <ArrowRight size={15} />
            </Link>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative hidden lg:block"
        >
          <img src={GOV_IMG} alt="Government building architecture" className="w-full h-[460px] object-cover border border-white/10" />
          <div className="absolute -bottom-5 -left-5 bg-[#FFD60A] text-black px-6 py-4">
            <p className="font-mono-tech text-[10px] tracking-[0.2em] uppercase">NAICS Ready</p>
            <p className="font-heading font-medium text-lg tracking-tight">{(s?.naics || []).slice(0, 3).join(" · ")}</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
